import toMatreshkaArray from '../_tomatreshkaarray.js';
import createSortingMethod from './createsortingmethod.js';
import createRemovingMethod from './createremovingmethod.js';
import createAddingMethod from './createaddingmethod.js';
import createSplice from './createsplice.js';
import createCopyWithin from './createcopywithin.js';
import createFill from './createfill.js';
import apply from '../../_helpers/apply.js';
// the methods that change the array; each also has a `name_` twin that takes event options last
export var changingMethodNames = ['push', 'pop', 'unshift', 'shift', 'sort', 'reverse', 'splice', 'copyWithin', 'fill'];
// the methods that copy; they return a Matreshka.Array
var copyingMethodNames = ['map', 'filter', 'slice', 'toSorted', 'toReversed', 'toSpliced', 'with'];
export var methodNames = [].concat(changingMethodNames, ['forEach', 'map', 'filter', 'slice', 'flat', 'flatMap', 'toSorted', 'toReversed', 'toSpliced', 'with', 'every', 'some', 'find', 'findIndex', 'findLast', 'findLastIndex', 'at', 'join', 'indexOf', 'lastIndexOf', 'includes', 'reduce', 'reduceRight', 'toString', 'toLocaleString']);
// the native methods are called on Matreshka.Array instances, which are array-like
var arrayPrototype = Array.prototype;
// a nested Matreshka.Array is spread like an array, as concat does: up to `depth` levels are made arrays
function spreadNested(value, depth) {
  return depth >= 1 && value && typeof value === 'object' && (value.isMatreshkaArray || Array.isArray(value)) ? arrayPrototype.map.call(value, function (item) {
    return spreadNested(item, depth - 1);
  }) : value;
}
function flat(depth) {
  var levels = typeof depth === 'undefined' ? 1 : +depth || 0;
  var items = arrayPrototype.map.call(this, function (item) {
    return spreadNested(item, levels);
  });
  return toMatreshkaArray(apply(arrayPrototype.flat, items, arguments));
}
function flatMap(callback, thisArg) {
  // a non-function goes as is, so the native method throws its TypeError
  var spreading = typeof callback === 'function' ? function spreadResult() {
    var result = apply(callback, this, arguments);
    return result && typeof result === 'object' && result.isMatreshkaArray ? result.toJSON(false) : result;
  } : callback;
  return toMatreshkaArray(arrayPrototype.flatMap.call(this, spreading, thisArg));
}
// creates pseudo native method and returns it (push, push_, sort, sort_...)
export default function createPseudoNativeMethod(name, hasOptions) {
  if (hasOptions === void 0) {
    hasOptions = false;
  }
  switch (name) {
    case 'sort':
    case 'reverse':
      return createSortingMethod(name, hasOptions);
    case 'pop':
    case 'shift':
      return createRemovingMethod(name, hasOptions);
    case 'push':
    case 'unshift':
      return createAddingMethod(name, hasOptions);
    case 'splice':
      return createSplice(hasOptions);
    case 'copyWithin':
      return createCopyWithin(hasOptions);
    case 'fill':
      return createFill(hasOptions);
    case 'flat':
      return flat;
    case 'flatMap':
      return flatMap;
    case 'forEach':
      return function pseudoNativeMethod() {
        apply(arrayPrototype.forEach, this, arguments);
        // return this for nicer chain calls
        return this;
      };
    default:
      if (copyingMethodNames.indexOf(name) !== -1) {
        return function pseudoNativeMethod() {
          return toMatreshkaArray(apply(arrayPrototype[name], this, arguments));
        };
      }
      // the other methods read the array and get the arguments as given: lastIndexOf(x, undefined) searches from 0
      return function pseudoNativeMethod() {
        return apply(arrayPrototype[name], this, arguments);
      };
  }
}